import React, { useRef } from 'react'
import { createUseStyles } from 'react-jss'
import { useSelector, useDispatch } from 'react-redux'
import { toggleCartDialog } from '../../redux/slices/layout'
import { getCartLineItemsCount } from '../../redux/slices/cart'
import { useHoverCursor } from '../Cursor'
import cn from 'classnames'
import theme from '../../style/theme'
import { vw } from '../../style/vw'
import { back } from '../../style/eases'

const CartButton = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const lineItemCount = useSelector(getCartLineItemsCount)
  const buttonRef = useRef()
  useHoverCursor(buttonRef)

  const handleOpenCart = () => {
    dispatch(toggleCartDialog())
  }

  return (
    <button
      className={cn(classes.menuButton, classes.cartButton)}
      onClick={handleOpenCart}
      aria-label='Open cart'
      ref={buttonRef}
    >
      <span className={classes.cartText}> Cart</span>
      {lineItemCount > 0 && (
        <span>({lineItemCount})</span>
      )}
    </button>
  )
}

const useStyles = createUseStyles({
  cartButton: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: [vw(4), vw(8)],
    background: 'transparent',
    color: 'currentColor',
    fontSize: vw(12),
    fontFamily: theme.fonts.headings,
    fontWeight: theme.fonts.headingsFontWeight,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '1px solid',
    borderColor: 'currentColor',

    '&:hover': {
      background: '#ffffff',
      color: '#000000'
    },

    [theme.breakpoints.up('md')]: {
      padding: [vw(8, 'desktop'), vw(12, 'desktop')],
      fontSize: vw(16, 'desktop')
    }
  },

  cartText: {
    display: 'inline-block',
    marginRight: vw(6),
    [theme.breakpoints.up('md')]: {
      marginRight: vw(6, 'desktop')
    }
  },

  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: vw(18),
    height: vw(18),
    borderRadius: '50%',
    backgroundColor: theme.colors.primary,
    color: theme.colors.white,
    fontSize: vw(10),
    fontWeight: 'bold',
    transform: 'scale(1)',
    transition: `transform 0.5s ${back.out}`,

    [theme.breakpoints.up('md')]: {
      width: vw(18, 'desktop'),
      height: vw(18, 'desktop'),
      fontSize: vw(10, 'desktop')
    },

    '& span': {
      fontFamily: theme.fonts.body,
      fontWeight: theme.fonts.bodyFontWeight,
      lineHeight: 1
    }
  }
}, { name: 'CartButton' })

export default CartButton
